// extracted by mini-css-extract-plugin
module.exports = {"section":"Paragraph_section__iv0Kq","paragraph":"Paragraph_paragraph__jHdQn"};